import React, { Component } from "react";
import * as Mui from "@material-ui/core";
import {
  IconAdd,
  IconColorBuilding,
  IconColorCanteen,
  IconColorOrganization,
  IconMail,
  IconPin,
  IconUsero,
} from "../../../components/svg";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
class Organization extends Component {
  constructor(props) {
    super(props);
    this.state = { buildingExpand: false, canteenExpand: false };
  }

  toggleBuidlingCollapse = (panel) => (event, isExpanded) => {
    this.setState({ buildingExpand: isExpanded ? panel : false });
  };

  toggleCanteenCollapse = (panel) => (event, isExpanded) => {
    this.setState({ canteenExpand: isExpanded ? panel : false });
  };



  render() {
    const { t } = this.props;
    return (
      <>
        <Mui.Grid
          container
          spacing={2}
          wrap="nowrap"
          alignItems="center"
          className="mb-1"
        >
          <Mui.Grid item xs md>
            <Mui.Box
              width={51}
              height={51}
              component="figure"
              bgcolor="#C9C9C9"
              className="img-round svg-size-medium"
            >
              <Mui.Box
                component="span"
                display="flex"
                justifyContent="center"
                mt={1.9}
              >
                <IconColorOrganization />
              </Mui.Box>
            </Mui.Box>
          </Mui.Grid>
          <Mui.Grid item xs={12} md={12}>
            <Mui.Typography
              component="h4"
              variant="h4"
              className="font-weight-medium"
            >
              {this.props.userData?.organizations?.name || ""}
              <Mui.Typography
                component="span"
                variant="body1"
                className="font-weight-normal text-color-grey d-block"
              >
                {t("ORGANIZATION.FORM.ORGANIZATION_NO")}:{" "}
                {this.props.userData?.organizations?.number || ""}
              </Mui.Typography>
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid container spacing={2} wrap="nowrap" alignItems="center">
          <Mui.Hidden mdDown>
            <Mui.Grid item xs md>
              <Mui.Box width={51} height={51} />
            </Mui.Grid>
          </Mui.Hidden>

          <Mui.Grid item xs={12} md={12}>
            {/* <Mui.Typography
              component="p"
              variant="subtitle2"
              className="mb-2 text-color-grey"
            >
              Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
              nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
              erat, sed diam voluptua. At vero eos et accusam et justo duo
              dolores et ea rebum. Stet clita kasd gubergren, no sea takimata
              sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit
              amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor
              invidunt ut labore et dolore magna aliquyam erat, sed diam
              voluptua. At vero eos et accusam et justo duo dolores et ea rebum.
              Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum
              dolor sit amet.
            </Mui.Typography> */}

            <Mui.Box
              display="flex"
              flexWrap="wrap"
              alignItems="center"
              mt={5}
              mb={8}
            >
              <Mui.Typography
                component="h5"
                variant="h5"
                className="d-flex align-items-center mb-2 mr-5 font-weight-normal svg-size-small svg-color-primary"
              >
                <IconUsero />
                <span className="ml-1">
                  {this.props.userData?.organizations?.adminUser?.[0]?.name ||
                    ""}
                </span>
              </Mui.Typography>
              <Mui.Typography
                component="h5"
                variant="h5"
                className="d-flex align-items-center mb-2 font-weight-normal svg-size-small svg-color-primary"
              >
                <IconMail />
                <span className="ml-1 word-break-word">
                  {this.props.userData?.organizations?.adminUser?.[0]?.email ||
                    ""}
                </span>
              </Mui.Typography>
            </Mui.Box>

            {this.props.userData?.userBuildingCanteens?.map((item, index) => (
              <div key={index}>
                <Mui.Accordion
                  expanded={this.state.buildingExpand === item.buildingId}
                  onChange={this.toggleBuidlingCollapse(item.buildingId)}
                  className="accordion-colored primary"
                >
                  <Mui.AccordionSummary expandIcon={<IconAdd />}>
                    <Mui.Box
                      width={51}
                      height={51}
                      component="figure"
                      bgcolor="#C9C9C9"
                      className="flex-shrink-0 img-round svg-size-medium"
                    >
                      <Mui.Box
                        component="span"
                        display="flex"
                        justifyContent="center"
                        mt={1.9}
                      >
                        <IconColorBuilding />
                      </Mui.Box>
                    </Mui.Box>

                    <Mui.Typography
                      component="h3"
                      variant="h3"
                      className="ml-2 font-weight-medium"
                    >
                      <Mui.Typography
                        component="span"
                        variant="h4"
                        className="d-block mt-1 mb-2 text-color-primary font-weight-medium"
                      >
                        {t("BUILDING.TITLE")}
                      </Mui.Typography>
                      {item?.buildings?.name}
                    </Mui.Typography>
                  </Mui.AccordionSummary>
                  <Mui.AccordionDetails>
                    <Mui.Box
                      ml={Mui.isWidthDown("sm", this.props.width) ? "0" : 9}
                    >
                      <Mui.Typography component="p" variant="body1">
                        {/* Lorem ipsum dolor sit amet, consetetur sadipscing elitr,
                      sed diam nonumy eirmod tempor invidunt ut labore et dolore
                      magna aliquyam erat, sed diam voluptua. At vero eos et
                      accusam et justo duo dolores et ea rebum. Stet clita */}
                      </Mui.Typography>

                      <Mui.Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="center"
                        mt={4}
                      >
                        <Mui.Typography
                          component="h5"
                          variant="h5"
                          className="d-flex align-items-center mb-2 mr-5 font-weight-normal svg-size-small svg-color-primary"
                        >
                          <IconUsero />
                          <span className="ml-1">
                            {item?.buildings?.buildingOwners?.[0]?.name || ""}
                          </span>
                        </Mui.Typography>

                        <Mui.Typography
                          component="h5"
                          variant="h5"
                          className="d-flex align-items-center mb-2 font-weight-normal svg-size-small svg-color-primary"
                        >
                          <IconMail />
                          <span className="ml-1 word-break-word">
                            {item?.buildings?.buildingOwners?.[0]?.email || ""}
                          </span>
                        </Mui.Typography>
                      </Mui.Box>
                    </Mui.Box>
                  </Mui.AccordionDetails>
                </Mui.Accordion>
                <Mui.Collapse
                  in={this.state.buildingExpand === item.buildingId}
                >
                  <Mui.Box
                    ml={Mui.isWidthDown("sm", this.props.width) ? "0" : 13}
                  >
                    {item?.canteens?.map((data, i) => (
                      <Mui.Accordion
                        key={i}
                        expanded={this.state.canteenExpand === data.id}
                        onChange={this.toggleCanteenCollapse(data.id)}
                        className="accordion-colored secondary"
                      >
                        <Mui.AccordionSummary expandIcon={<IconAdd />}>
                          <Mui.Box
                            width={51}
                            height={51}
                            display="flex"
                            justifyContent="center"
                            component="figure"
                            bgcolor="#C9C9C9"
                            className="img-round svg-size-medium"
                            pt={1}
                          >
                            <IconColorCanteen />
                          </Mui.Box>

                          <Mui.Typography
                            component="h3"
                            variant="h3"
                            className="ml-2 font-weight-medium"
                          >
                            <Mui.Typography
                              component="span"
                              variant="h4"
                              className="d-block mt-1 mb-2 text-color-primary font-weight-medium"
                            >
                              {t("CANTEEN.TITLE")}
                            </Mui.Typography>
                            {data?.name || ""}
                          </Mui.Typography>
                        </Mui.AccordionSummary>
                        <Mui.AccordionDetails>
                          <Mui.Box
                            width="100%"
                            ml={
                              Mui.isWidthDown("sm", this.props.width) ? "0" : 9
                            }
                          >
                            <Mui.Typography component="p" variant="body1">
                              {/* Lorem ipsum dolor sit amet, consetetur sadipscing
                              elitr, sed diam nonumy eirmod tempor invidunt ut
                              labore et dolore magna aliquyam erat, sed diam
                              voluptua. At vero eos et accusam et justo duo
                              dolores et ea rebum. Stet clita */}
                            </Mui.Typography>

                            <Mui.Box display="flex" alignItems="center" mb={5}>
                              <Mui.Typography
                                component="h5"
                                variant="h5"
                                className="d-flex align-items-center font-weight-normal svg-size-small svg-color-primary"
                              >
                                <IconPin />
                                <span className="ml-1">
                                  {data?.locationInBuilding || ""}
                                </span>
                              </Mui.Typography>
                            </Mui.Box>

                            <Mui.Divider light={true} className="mb-3" />

                            <Mui.Typography
                              component="h6"
                              variant="h6"
                              className="mb-1 font-weight-medium"
                            >
                              {t("CANTEEN.TIME_SLOTS_LABEL")}
                            </Mui.Typography>

                            <Mui.TableContainer className="default-datatable">
                              <Mui.Table size={"medium"}>
                                <Mui.TableHead>
                                  <Mui.TableRow>
                                    <Mui.TableCell className="font-weight-normal ">
                                      {t("CANTEEN.FORM.OPENING_DAYS")}
                                    </Mui.TableCell>
                                    <Mui.TableCell className="font-weight-normal ">
                                      {t("CANTEEN.FORM.OPENING_TIME")}
                                    </Mui.TableCell>
                                    <Mui.TableCell className="font-weight-normal text-left">
                                      {t("CANTEEN.FORM.CLOSING_TIME")}
                                    </Mui.TableCell>
                                    <Mui.TableCell className="font-weight-normal ">
                                      {t("COMMON.FORM.STATUS")}
                                    </Mui.TableCell>
                                  </Mui.TableRow>
                                </Mui.TableHead>

                                <Mui.TableBody>
                                  {data?.canteenTimeslots?.map((slots, k) => (
                                    <Mui.TableRow key={k}>
                                      <Mui.TableCell className="text-transform-capitalize">
                                        {slots.day}
                                      </Mui.TableCell>
                                      <Mui.TableCell>
                                        {slots?.openingTime || "-"}
                                      </Mui.TableCell>
                                      <Mui.TableCell className="text-left">
                                        {slots?.closingTime || "-"}
                                      </Mui.TableCell>
                                      <Mui.TableCell>
                                        <span
                                          className={`status-bg ${slots?.status === 1
                                            ? "success"
                                            : "disabled"
                                            }`}
                                        >
                                          {slots?.status === 1
                                            ? t("COMMON.OPEN")
                                            : t("COMMON.CLOSED")}
                                        </span>
                                      </Mui.TableCell>
                                    </Mui.TableRow>
                                  ))}
                                </Mui.TableBody>
                              </Mui.Table>
                            </Mui.TableContainer>
                          </Mui.Box>
                        </Mui.AccordionDetails>
                      </Mui.Accordion>
                    ))}
                  </Mui.Box>
                </Mui.Collapse>
              </div>
            ))}
          </Mui.Grid>
        </Mui.Grid>
      </>
    );
  }
}
const mapStateToProps = ({ user }) => {
  const { userData } = user;
  return { userData };
};
export default connect(
  mapStateToProps,
  {}
)(withTranslation()(Mui.withWidth()(Organization)));
